/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontProductTile_user$ref = any;
export type StorefrontProductGrid_user$ref = any;
export type StorefrontProductGrid_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": StorefrontProductTile_user$ref;
    readonly " $refType": StorefrontProductGrid_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontProductGrid_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "StorefrontProductTile_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'afdf0ee6cbdf3256b81521631216ee4f';
export default node;
